import Constants from '~/actions/Constants'

const defaultState = {
  resource : null,
  byOwner : {}
}

export default function resourceReducer( state = defaultState, action ) {
  switch ( action.type ) {
    case Constants.GET_RESOURCE:
      return {
        ...state,
        resource : action.payload
      }
    case Constants.GET_RESOURCES:
      return {
        ...state,
        byOwner : {
          ...state.byOwner,
          ...action.payload.items.reduce( ( prev, curr ) => {
            if ( !prev[curr.ownerId] ) {
              prev[curr.ownerId] = {}
            }

            prev[curr.ownerId][curr.id] = curr

            return prev
          }, {} )
        }
      }
    default:
      return state
  }
}

resourceReducer.getByOwnerId = ( state = {}, ownerId ) => {
  return state.resource?.byOwner?.[ownerId]
}
